
import * as ipxRuntime$_4ukLVUsuI1bOAA6uAIXTGYEZws4Lx6R5ueNHe2mnPdM from '/src/app/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 576,
    "sm": 768,
    "md": 996,
    "lg": 1200,
    "xl": 1367,
    "xxl": 1600,
    "2xl": 1536,
    "default": 320,
    "xxs": 480,
    "4k": 1921
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "img.youtube.com",
    "i.vimeocdn.com"
  ],
  "alias": {
    "/youtube": "https://img.youtube.com",
    "/vimeo": "https://i.vimeocdn.com"
  },
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$_4ukLVUsuI1bOAA6uAIXTGYEZws4Lx6R5ueNHe2mnPdM, defaults: {} }
}
        